import { __unsafe_do_no_use_FLEX_SYSTEM_PROPS } from '@mantine/core';
import { FlexDemos } from '@mantine/demos';
import { StylePropsTable } from "../../../../src/components/StylePropsTable/StylePropsTable";
import * as React from 'react';
export default {
  __unsafe_do_no_use_FLEX_SYSTEM_PROPS,
  FlexDemos,
  StylePropsTable,
  React
};